export default __webpack_public_path__ + "static/media/diamond-clarity.ed64c854.png";